module.exports = __webpack_public_path__ + "img/add-photo-second-icon.2f2f7ef2.svg";